import React from "react";
import EditDetailsForm from "./components/EditDetails";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
function EditDetails() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox>
        <EditDetailsForm />
      </MDBox>
    </DashboardLayout>
  );
}

export default EditDetails;
